var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "AutoHandover"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-top": "-18px"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areaBarcode),
      expression: "areaBarcode"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Handover Area Barcode",
      "name": "AreaBarcode",
      "id": "AreaBarcode"
    },
    domProps: {
      "value": (_vm.areaBarcode)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getBarcodeScan.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        return _vm.getBarcodeScan.apply(null, arguments)
      }],
      "blur": _vm.getBarcodeScan,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.areaBarcode = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.handOverAreaErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.handOverAreaErrorMSG))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entityName),
      expression: "entityName"
    }],
    attrs: {
      "type": "text",
      "name": "EntityName",
      "readonly": "",
      "placeholder": "Handover entity name",
      "id": "EntityName"
    },
    domProps: {
      "value": (_vm.entityName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entityName = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "disabled": _vm.isBarcodeScan,
      "type": "submit"
    },
    on: {
      "click": _vm.startScan
    }
  }, [_vm._v("Start Scan")]), _vm._v("  \n                    "), _c('button', {
    staticClass: "common-secondary mr-2 btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])])]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.bagInscan.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagNo),
      expression: "bagNo"
    }],
    ref: "awbBag",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag no",
      "name": "BagNo"
    },
    domProps: {
      "value": (_vm.bagNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagNo = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.bagNoErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.bagNoErrorMSG))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "disabled": _vm.disabled,
      "type": "submit"
    }
  }, [_vm._v("InScan")]), _vm._v("  \n                  "), _c('button', {
    staticClass: "common-secondary mr-2 btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag/Mps Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Handing Over Entity")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("TimeStamp")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [(_vm.autoHandoverBatchData.length < 1) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.autoHandoverBatchData), function(data, index) {
    return (_vm.autoHandoverBatchData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.handoverEntity))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.timestamp))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeBag(data)
        }
      }
    }, [_vm._v("Remove")])])]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('b-button', {
    staticClass: "common-success",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.openConfirmationModal(true)
      }
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('b-button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.openConfirmationModal(false)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)])])], 1)])]), _vm._v(" "), (_vm.ConfirmationModal == true) ? _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ConfirmationModal),
      callback: function($$v) {
        _vm.ConfirmationModal = $$v
      },
      expression: "ConfirmationModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeConfirmationModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.showConfirm) ? _c('b', {
    staticStyle: {
      "color": "rgb(19, 18, 18)"
    }
  }, [_vm._v("Do you want to confirm all bags?")]) : _c('b', {
    staticStyle: {
      "color": "rgb(19, 18, 18)"
    }
  }, [_vm._v("Do you want to cancel all bags?")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.showConfirm) ? _c('b-button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmBagHandover
    }
  }, [_vm._v("Yes")]) : _c('b-button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeAllBag
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('b-button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeConfirmationModal
    }
  }, [_vm._v("No")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  })])])]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1acb9585","hasScoped":true}!./src/views/components/AutoHandover/Handover/Handover.html
// module id = 1749
// module chunks = 2